var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 106,
    viewBox: "0 0 125 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.56 79.7441C101.56 79.7441 89.9614 103.111 60.9217 103.98C31.882 104.849 17.9289 76.9644 17.9289 76.9644C17.9289 76.9644 -27.7994 0 62.3721 0C153.59 0 101.56 79.7441 101.56 79.7441Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38230_16861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 111,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.56 79.7443C101.56 79.7443 89.9614 103.112 60.9217 103.98C31.882 104.849 17.9289 76.9645 17.9289 76.9645C17.9289 76.9645 -27.7994 0.00012207 62.3721 0.00012207C153.59 0.00012207 101.56 79.7443 101.56 79.7443Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38230_16861)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0156 74.3752C81.6523 69.2763 85.5673 62.1721 87.6079 55.4387C92.6394 42.4509 83.1856 28.7697 69.0579 24.488C54.9301 20.2064 40.9309 29.655 37.7006 40.3136C35.4581 47.7132 35.8777 56.3563 37.3436 63.6859C37.9953 66.944 39.9694 70.1419 42.966 72.8698C41.5118 73.3775 40.6532 74.6511 40.9228 77.1306C41.4777 82.2339 40.5585 87.36 39.6204 92.5907C38.1209 100.952 36.5734 109.581 40.9228 118.813C61.5128 123.873 73.8848 122.826 79.2941 118.813C85.0537 114.54 83.145 98.8801 81.9216 88.8429C81.5432 85.738 81.2304 83.1712 81.2304 81.6459C81.2304 78.3321 78.9747 75.3714 77.0156 74.3752Z",
    fill: "#F47226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9128 71.6564C52.8921 71.6472 52.872 71.6382 52.8525 71.6293C52.8729 71.6355 52.8929 71.6446 52.9128 71.6564C55.5416 72.8303 67.3449 76.6345 69.4304 75.5267C72.0579 74.1311 66.0311 81.2923 64.1224 81.8288C60.7552 82.7752 59.5123 82.2407 57.2548 80.6606C54.2879 78.584 53.8334 72.2039 52.9128 71.6564Z",
    fill: "#005C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.512 55.9667C85.3917 53.6596 85.3566 54.02 87.0548 49.3963C88.753 44.7726 82.5081 40.9522 79.1044 37.6187C75.7007 34.2852 74.1889 31.0322 64.6366 30.18C55.0842 29.3277 53.4722 33.0143 50.3551 34.6122C47.238 36.21 43.4049 33.1413 39.5324 43.1891C37.6999 48.6987 39.6993 61.2746 43.6746 67.1634C47.6499 73.0522 53.8974 75.8488 60.531 76.6438C65.7944 77.2746 74.6628 74.6804 80.4586 66.5982C82.245 64.1071 83.232 59.324 84.512 55.9667Z",
    fill: "#005C90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0352 57.6782C81.7643 59.667 77.8731 62.0857 73.8544 61.6243C70.8035 61.2741 69.6463 60.028 68.4705 58.7619C67.2562 57.4542 66.0219 56.1251 62.6608 55.7393C59.3179 55.3555 57.883 56.3654 56.4635 57.3646C55.0738 58.3427 53.6988 59.3105 50.5626 58.9505C45.4907 58.3683 40.7112 54.7529 39.0933 53.0338C38.991 53.9246 38.9757 55.1102 39.1053 56.4814C40.5849 61.7941 43.3554 67.5667 46.4174 70.706C51.3852 75.7992 58.0494 77.4472 64.7405 77.0567C70.0496 76.747 78.3475 72.6256 82.6401 63.6459C83.3741 62.1103 83.7403 59.9237 84.0352 57.6782Z",
    fill: "#0193D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5847,
    cy: 47.6425,
    rx: 4.22724,
    ry: 5.46215,
    transform: "rotate(1.77097 52.5847 47.6425)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.5655,
    cy: 50.1284,
    rx: 4.0207,
    ry: 5.19528,
    transform: "rotate(15.2347 74.5655 50.1284)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0175 84.9331C15.0176 82.4331 11.5176 83.4332 15.5176 89.4332C19.4173 95.2829 27.5175 102.933 34.0175 102.933C44.0176 93.9332 40.5175 79.9331 41.0175 75.4331C31.5176 75.4331 31.0175 92.582 28.7941 92.582C26.5707 92.582 23.0174 87.4331 19.0175 84.9331Z",
    fill: "#005C90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.518 81.4333C108.297 78.6103 113.506 79.1223 110.018 85.4333C106.616 91.5862 97.0175 97.9332 87.5175 98.4332C77.5176 98.9595 86.0174 80.4332 76.5176 74.9334C90.0175 58.9332 88.1109 86.6785 91.0176 85.4333C93.9242 84.188 100.739 84.2562 104.518 81.4333Z",
    fill: "#005C90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5585 82.9694C11.8633 81.3457 7.59801 84.459 4.90761 86.6359C4.90766 89.7936 6.82448 94.4573 10.919 95.7079C13.1764 96.3974 15.091 94.5533 16.8333 91.6134C18.9529 88.0367 20.4728 85.2441 14.5585 82.9694Z",
    fill: "#005C90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30171 81.4646C6.75141 80.4076 5.53401 80.7111 5.73708 83.2867C6.05112 85.3664 8.92505 86.4997 10.9871 87.1604C12.3305 86.9417 13.1451 85.6272 13.2145 83.6156C13.2991 81.1683 10.2396 82.7859 8.30171 81.4646Z",
    fill: "#005C90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.414363 90.6658C-0.683517 88.6729 2.60163 87.8861 4.59791 86.6109C6.57513 85.4861 7.19123 87.8573 6.0594 89.548C4.92757 91.2387 1.49876 92.6342 0.414363 90.6658Z",
    fill: "#005C90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27485 95.7079C0.93474 93.8692 4.87171 92.1814 6.6915 90.6649C8.51132 89.3 9.42115 91.5748 8.51125 93.3945C7.60136 95.2143 3.59852 97.524 2.27485 95.7079Z",
    fill: "#005C90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5147 97.8423C4.91655 96.2228 8.43416 95.2028 10.0087 93.4331C11.6059 91.8133 12.2733 93.2978 11.6435 95.2325C11.0138 97.1671 8.09323 99.4419 6.5147 97.8423Z",
    fill: "#005C90"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 79.4186C111.789 77.6342 116.477 81.0557 119.434 83.4482C119.434 86.9186 117.327 92.0441 112.827 93.4186C110.346 94.1764 108.242 92.1497 106.327 88.9186C103.998 84.9878 102.327 81.9186 108.827 79.4186Z",
    fill: "#005C90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.703 77.7649C117.407 76.6032 118.745 76.9367 118.522 79.7675C118.177 82.0531 115.018 83.2986 112.752 84.0247C111.276 83.7844 110.38 82.3397 110.304 80.1289C110.211 77.4393 113.574 79.217 115.703 77.7649Z",
    fill: "#005C90"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.372 87.8773C125.578 85.6871 121.968 84.8223 119.774 83.4208C117.601 82.1847 116.924 84.7907 118.168 86.6488C119.412 88.507 123.18 90.0406 124.372 87.8773Z",
    fill: "#005C90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.327 93.4186C123.8 91.3978 119.473 89.5428 117.473 87.8761C115.473 86.3761 114.473 88.8761 115.473 90.8761C116.473 92.8761 120.872 95.4146 122.327 93.4186Z",
    fill: "#005C90"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.667 95.7644C119.424 93.9845 115.558 92.8636 113.827 90.9186C112.072 89.1384 111.338 90.7699 112.03 92.8961C112.723 95.0224 115.932 97.5224 117.667 95.7644Z",
    fill: "#005C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataDark);
export default __webpack_public_path__ + "static/media/noData_dark.b284dcb07faefeba46a1448097dbb476.svg";
export { ForwardRef as ReactComponent };